module.exports = __webpack_public_path__ + "static/media/zoom-icon.e9662fc6.svg";